<template lang="pug">
  div
    div.row
      div.col-md-12.mb-1
        span.font-weight-bolder.text-uppercase {{ $t('ui.linked_match_info') }}
    div.row.mb-1
      div.col
        SubmitButton(
          :loading="loading"
          icon="icon-arrow-left"
          :text="$t('ui.back')"
          type="button"
          @click.native="$emit('backFromOddsLvl')"
          variant="secondary"
          size="sm"
          ).mb-1.mr-1
        SubmitButton(
          :loading="loading"
          icon="icon-reload"
          :text="$t('ui.refresh')"
          type="button"
          @click="refresh()"
          variant="info"
          size="sm"
          ).mb-1
    div.row.mb-3(v-if="item && matchInfo").animated.fadeIn
      div.col
        b-form-group(:label="$tc('ui.matches', 1)" v-if="matchInfo['match'] && matchInfo['match'].length > 0").mb-2
          table.tablex(style="width: 100%;" v-columns-resizable)
            thead
              tr
                th(width=100)
                  span {{ $t('ui.id') }}
                th(width=80)
                  span {{ $tc('ui.sports', 1) }}
                th
                  span {{ $tc("ui.leagues", 1) }}
                th(width=200)
                  span {{ $t("ui.home") }}
                th(width=200)
                  span {{ $t("ui.away") }}
                th(width=80)
                  span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                th(width=80)
                  span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                th(width=80)
                  span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                th(width=80)
                  span {{ $t("ui.sbo") }}
                th(width=80)
                  span {{ $t("ui.ibc") }}
                th.text-center(width=60)
                  span(:title="$t('ui.affect_value')") {{ $t("ui.short.affect_value") }}
                th.text-center(width=60)
                  span {{ $t("ui.ldiff") }}
                th(width=60)
                  span {{ $t("ui.linked") }}
            tbody
              tr(v-for="item in matchInfo['match']")
                td
                  span {{ item.match_id }}
                td
                  span {{ item.sport_type }}
                td
                  span(:title="item.league_name") {{ item.league_name }}
                td
                  span(:title="item.home_team") {{ item.home_team }}
                td
                  span(:title="item.away_team") {{ item.away_team }}
                td.text-uppercase
                  span {{ item.market_type }}
                td
                  span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                td
                  span {{ item.match_time }}
                td
                  span {{ item.sbo_map }}
                td
                  span {{ item.ibc_map }}
                td
                  select(@change="changedAffectValue(item, $event)" :value="getDecimal(item.affect_value)")
                    option(v-for="affValueInfo in affValueList" v-bind:value="affValueInfo.value")
                      | {{ affValueInfo.text }}
                td.actions
                  div.d-flex.justify-content-center.align-items-center
                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                      input.switch-input(type="checkbox" v-model="item.ldiff" @change="changedBoolValue(item, $event, 'ldiff')")
                      span.switch-slider(:data-checked='on' :data-unchecked='off')
                td
                  span {{ item.link_id }}
        b-form-group(:label="$t('ui.sbo')" v-if="matchInfo['sbo'] && matchInfo['sbo'].length > 0").mb-2
          table.tablex(style="width: 100%;" v-columns-resizable)
            thead
              tr
                th(width=100)
                  span {{ $t('ui.id') }}
                th(width=80)
                  span {{ $tc('ui.sports', 1) }}
                th
                  span {{ $tc("ui.leagues", 1) }}
                th(width=200)
                  span {{ $t("ui.home") }}
                th(width=200)
                  span {{ $t("ui.away") }}
                th(width=80)
                  span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                th(width=80)
                  span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                th(width=80)
                  span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                th(width=80)
                  span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                th(width=60)
                  span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                th(width=60)
                  span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                th(width=50)
                  span(:title="$t('ui.home_red_card')") {{ $t("ui.short.home_red_card") }}
                th(width=50)
                  span(:title="$t('ui.away_red_card')") {{ $t("ui.short.away_red_card") }}
                th(width=200)
                  span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
                th(width=100)
                  span(:title="$t('ui.ref_id')") {{ $t("ui.ref_id") }}
            tbody
              tr(v-for="item in matchInfo['sbo']")
                td
                  span(:title="item.match_id") {{ item.match_id }}
                td
                  span(:title="item.sport_type") {{ item.sport_type }}
                td
                  span(:title="item.league_name") {{ item.league_name }}
                td
                  span(:title="item.home_team") {{ item.home_team }}
                td
                  span(:title="item.away_team") {{ item.away_team }}
                td.text-uppercase
                  span(:title="item.market_type") {{ item.market_type }}
                td
                  span(:title="$moment(item.match_date).format('YYYY-MM-DD')") {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                td
                  span(:title="item.match_time") {{ item.match_time }}
                td
                  span(:title="item.match_link") {{ item.match_link }}
                td
                  span(:title="item.running_score") {{ item.running_score }}
                td
                  span(:title="item.running_time") {{ item.running_time }}
                td
                  span(:title="item.hrc") {{ item.hrc }}
                td
                  span(:title="item.arc") {{ item.arc }}
                td
                  span(:title="item.parent_league")  {{ item.parent_league }}
                td
                  span(:title="item.ref_id")  {{ item.ref_id }}
        b-form-group(:label="$t('ui.ibc')" v-if="matchInfo['ibc'] && matchInfo['ibc'].length > 0").mb-2
          table.tablex(style="width: 100%;" v-columns-resizable)
            thead
              tr
                th(width=100)
                  span {{ $t('ui.id') }}
                th(width=80)
                  span {{ $tc('ui.sports', 1) }}
                th
                  span {{ $tc("ui.leagues", 1) }}
                th(width=200)
                  span {{ $t("ui.home") }}
                th(width=200)
                  span {{ $t("ui.away") }}
                th(width=80)
                  span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                th(width=80)
                  span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                th(width=80)
                  span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                th(width=80)
                  span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                th(width=60)
                  span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                th(width=60)
                  span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                th(width=50)
                  span(:title="$t('ui.home_red_card')") {{ $t("ui.short.home_red_card") }}
                th(width=50)
                  span(:title="$t('ui.away_red_card')") {{ $t("ui.short.away_red_card") }}
                th(width=200)
                  span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
            tbody
              tr(v-for="item in matchInfo['ibc']")
                td
                  span(:title="item.match_id") {{ item.match_id }}
                td
                  span(:title="item.sport_type") {{ item.sport_type }}
                td
                  span(:title="item.league_name") {{ item.league_name }}
                td
                  span(:title="item.home_team") {{ item.home_team }}
                td
                  span(:title="item.away_team") {{ item.away_team }}
                td.text-uppercase
                  span(:title="item.market_type") {{ item.market_type }}
                td
                  span(:title="$moment(item.match_date).format('YYYY-MM-DD')") {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                td
                  span(:title="item.match_time") {{ item.match_time }}
                td
                  span(:title="item.match_link") {{ item.match_link }}
                td
                  span(:title="item.running_score") {{ item.running_score }}
                td
                  span(:title="item.running_time") {{ item.running_time }}
                td
                  span(:title="item.hrc") {{ item.hrc }}
                td
                  span(:title="item.arc") {{ item.arc }}
                td
                  span(:title="item.parent_league")  {{ item.parent_league }}
    div.row.mb-3(v-if="groups")
      div.col
        b-form-radio-group(v-model="selectedGroup" :options="groupItems" buttons button-variant="outline-secondary" size="sm" @change="resetLog($event)" :disabled="loading")
    div.row.mb-3(v-if="selectedGroup && details").animated.fadeIn
      div.col
        div.row
          div.col-md-6.clusterize
            b-form-group(:label="$tc('ui.matches', 1)" v-if="details['match'] && details['match'].length > 0").mb-3
              .clusterize-scroll(style="max-width: 820px;")
                table.tablex(style="width: 100%; table-layout: auto;" v-columns-resizable)
                  thead
                    tr
                      th.text-center(v-for="(v, k) in details['match'][0]" v-if="k != 'update_time'")
                        span {{ k }}
                      th.text-center
                        span update_time
                  tbody.clusterize-content
                    tr(v-for="item in details['match']")
                      td.text-uppercase.text-center
                        b-link.clickable(href="javascript:void(0);" @click="getLogs(item)" v-if="!loading") {{ item["match_id"] }}
                        span(v-else) {{ item["match_id"] }}
                      td.text-uppercase.text-center
                        span {{ item["ot"] }}
                      td.text-uppercase.text-center(v-for="(v, k) in item" v-if="k != 'match_id' && k != 'ot' && k != 'update_time'" style="min-width: 40px;")
                        span(v-if="k == 'calculated_from'") {{ oddsCalculateFrom[item["calculated_from"]] }}
                        span(v-else) {{ v }}
                      td.text-uppercase.text-center
                        span {{ $moment(item["update_time"]).format("YYYY-MM-DD hh:mm:ss.SSS A") }}
            b-form-group(:label="$t('ui.sbo')" v-if="details['sbo'] && details['sbo'].length > 0").mb-3
              .clusterize-scroll(style="max-width: 820px;")
                table.tablex(style="width: 100%; table-layout: auto;" v-columns-resizable)
                  thead
                    tr
                      th.text-center.sticky-position(v-for="(v, k) in details['sbo'][0]")
                        span(v-if="k == 'epoch_time'") DateTime
                        span(v-else) {{ k }}
                  tbody.clusterize-content
                    tr(v-for="item in details['sbo']")
                      td.text-uppercase.text-center(v-for="(v, k) in item" style="min-width: 40px;")
                        span(v-if="k!='epoch_time'") {{ v }}
                        span(v-else) {{ $moment(v / 1000000).format("YYYY-MM-DD hh:mm:ss.SSS A") }}
            b-form-group(:label="$t('ui.ibc')" v-if="details['ibc'] && details['ibc'].length > 0").mb-3
              .clusterize-scroll(style="max-width: 820px;")
                table.tablex(style="width: 100%; table-layout: auto;" v-columns-resizable)
                  thead
                    tr
                      th.text-center.sticky-position(v-for="(v, k) in details['ibc'][0]")
                        span(v-if="k == 'epoch_time'") DateTime
                        span(v-else) {{ k }}
                  tbody.clusterize-content
                    tr(v-for="item in details['ibc']")
                      td.text-uppercase.text-center(v-for="(v, k) in item" style="min-width: 40px;")
                        span(v-if="k!='epoch_time'") {{ v }}
                        span(v-else) {{ $moment(v / 1000000).format("YYYY-MM-DD hh:mm:ss.SSS A") }}
          div(v-if="loading").col-md-6.clusterize.animated.fadeIn
            i
              div.fa.fa-spinner.fa-spin
          div(v-if="logs && !loading").col-md-6.animated.fadeIn
            div.row
              div.col-md-4
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="matchOddsTotalRow"
                  :per-page="$store.getters.pageSize"
                  v-model="currentMatchOddsPage"
                  @input="changedOddsPage($event)").mb-1
              div.col-md-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.from") }}
                  date-picker(v-model="dStartDate" :config="locale" @blur.native="refresh()")
              div.col-md-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.to") }}
                  date-picker(v-model="dEndDate" :config="locale" @blur.native="refresh()")
              div.col-md-2
                b-input-group(size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="$store.getters.pageSize" @input="changedOddsPageSize")
                  b-input(:value="matchOddsTotalRow" readonly)
            div.clusterize-scroll(style="max-height: 300px; max-width: 820px;")
              table.tablex(style="width: 100%; table-layout: auto;" v-if="logs && logs.length > 0 && !loading" v-columns-resizable)
                thead
                  tr
                    th.text-center.sticky-position(v-for="(v, k) in logs[0]")
                      span {{ k }}
                tbody.clusterize-content
                  tr(v-for="(v, k) in logs")
                    td(v-for="(i, j) in v")
                      span.text-uppercase(v-if="j == 'calculated_from'") {{ oddsCalculateFrom[i] }}
                      span.text-uppercase(v-else) {{ i }}
              table.tablex(style="width: 100%; table-layout: auto;" v-else)
                thead
                  tr
                    th
                      span &nbsp;
                tbody.clusterize-content
                  tr
                    td(colspan="100%").text-center
                      span {{ $t('message.no_data_available') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton,
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      info: null,
      betType: null,
      logs: null,
      selectedGroup: null,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentMatchOddsPage: 1,
      matchOddsTotalRow: 0,
      currentOddsDetailInfo: null,
      dStartDate: null,
      dEndDate: null,
      // locale: {
      //   format: "YYYY-MM-DD",
      //   useCurrent: true
      // },
      locale: {
        format: 'YYYY-MM-DD hh:mm A',
        useCurrent: false,
        showClear: true,
        showClose: true,
      },
      affValueList: [],
      oddsCalculateFrom: config.oddsCalculateFrom,
      matchInfo: null
    };
  },
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWithTime() {
      let time = '23:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    groupItems: function() {
      if (this.groups) {
        var list = [];
        for (var prop in this.groups) {
          list.push({
            text: this.groups[prop].bet_type + " (" + this.groups[prop].ot_count + ")",
            value: this.groups[prop].bet_type
          });
        }
        return list;
      } else {
        return null;
      }
    },
    groups() {
      if (this.betType) {
        return this.betType;
      } else {
        return null;
      }
    },
    details() {
      if (this.info) {
        return this.info;
      } else {
        return null;
      }
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.reset();
    // this.getOddsInfo(this.item);
    this.getMatchInfo(this.item);
    this.getOddsBetType(this.item);
    this.getAffectValueList();
    this.dStartDate = this.yesterdayWithTime;
    this.dEndDate = this.todayWithTime;
  },
  methods: {
    resetLog(betType) {
      this.logs = null;
      this.currentOddsDetailInfo = null;
      this.currentMatchOddsPage = 1;
      this.getOddsInfo(this.item, betType);
    },
    reset() {
      this.selectedGroup = null;
      this.betType = null;
      this.info = null;
      this.matchInfo = null;
      this.logs = null;
      this.currentOddsDetailInfo = null;
    },
    refresh() {
      this.getMatchInfo(this.item);

      if (this.selectedGroup) {
        this.getOddsBetType(this.item);
        this.getOddsInfo(this.item, this.selectedGroup);
        if (this.logs) {
          this.currentMatchOddsPage = 1;
          this.getLogs(this.currentOddsDetailInfo);
        }
      }
    },
    getDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    changedBoolValue: function(item, eventStatus, prop) {
      this.$helpers
        .alert({
          title: this.$t("ui." + prop),
          text: this.$t("message.change_" + prop + "_confirm", { name: item.match_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBoolValue(item, eventStatus.srcElement.checked, prop);
          } else {
            eventStatus.srcElement.checked = !item[prop];
          }
        });
    },
    confirmBoolValue: function(item, status, prop) {
      let url = "";

      if (prop == "cmd_enabled") url = config.editMatchCMDEnabledUrl();
      else if (prop == "semi_auto") url = config.editMatchSemiAutoUrl();
      else if (prop == "ldiff") url = config.editMatchLdiffUrl();
      else if (prop == "auto_open") url = config.editMatchAutoOpenUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        // match_id: item.match_id
        match_id_str: item.match_id
      };

      json[prop] = status;

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item[prop] = status;
                // this.$helpers.showDialog(this.$t("ui." + prop), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedAffectValue: function(affValue, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.affect_value"),
          text: this.$t("message.change_affect_value_confirm", { name: affValue.match_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAffectValue(affValue, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = parseFloat(affValue.affect_value).toFixed(2);
          }
        });
    },
    confirmAffectValue: function(affValue, value) {
      let url = config.updateMatchAffectValueUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        match_id_str: affValue.match_id,
        // match_id: affValue.match_id,
        affect_value: value
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                affValue.affect_value = value;
                this.$snotify.success(this.$t("message.success"));
                // this.$helpers.showDialog(this.$t("ui.affect_value"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getAffectValueList: function() {
      for (var i = 0.0; i <= 1.0; i += 0.1) {
        this.affValueList.push({
          value: parseFloat(i).toFixed(2),
          text: i.toFixed(2)
        });
      }
    },
    getOddsBetType(val) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      let url = config.matchOddsBetTypeUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.match_id,
        page_id: config.accessRoles.linkedmatch
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.betType = response.data.tbl_match_odds_bet_type;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMatchInfo(val) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      if (!val.sbo_map && !val.ibc_map) {
        return;
      }

      let url = config.matchInfoUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.match_id,
        sbo_match_id: val.sbo_map,
        ibc_match_id: val.ibc_map,
        page_id: config.accessRoles.linkedmatch
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.matchInfo = response.data.tbl_match_info;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getOddsInfo(val, betType) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      if (!val.sbo_map && !val.ibc_map) {
        return;
      }

      let url = config.matchOddsInfoUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.match_id,
        sbo_match_id: val.sbo_map,
        ibc_match_id: val.ibc_map,
        bet_type: betType,
        page_id: config.accessRoles.linkedmatch
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.info = response.data.tbl_match_odds_info;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLogs(val) {
      if (!val) {
        return;
      }

      if (!val.match_id || !val.ot) {
        return;
      }

      this.currentOddsDetailInfo = val;

      let url = config.matchOddsLogsUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        group_id: this.selectedGroup,
        match_id: val.match_id,
        ot: val.ot,
        page_id: config.accessRoles.linkedmatch,
        page_number: this.currentMatchOddsPage,
        page_size: this.$store.getters.pageSize,
        date_from: this.dStartDate,
        date_to: this.dEndDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              this.matchOddsTotalRow = response.data.tbl_match_odds_logs["Table"].length > 0 ? response.data.tbl_match_odds_logs["Table"][0].totalrows : 0;

              if (this.feedback.success == true) {
                var n = response.data.tbl_match_odds_logs["Table"];
                var m = [];
                for (var i in n) {
                  var ep = n[i].created_date;
                  n[i].timestamp = this.$moment(ep).format("YYYY-MM-DD hh:mm:ss.SSS A");
                  delete n[i].created_date;
                  delete n[i].row_id;
                  delete n[i].match_id;
                  delete n[i].ot;
                  delete n[i].totalrows;
                  m.push(n[i]);
                }
                this.logs = m;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedOddsPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentMatchOddsPage = 1;
      this.getLogs(this.currentOddsDetailInfo);
    },
    changedOddsPage: function(pageNo) {
      this.currentMatchOddsPage = pageNo;
      this.getLogs(this.currentOddsDetailInfo);
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
